import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import Moment from 'moment'
import Multiselect from 'vue-multiselect'
import router from './router'
import VueRecaptcha from 'vue-recaptcha'
import VueGtag from 'vue-gtag'
import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(BootstrapVue)

library.add(fas)

Axios.defaults.headers.common['Content-Type'] = 'application/json'

Vue.prototype.$apiUrl = 'https://digitalcorp.cl:8443/api.teconecto-1.1/'
Vue.prototype.$apiUser = { username: 'teconecto', password: 'teconecto.123' }
Vue.prototype.$http = Axios
Vue.prototype.$moment = Moment
Vue.prototype.$library = library

Vue.component('fa', FontAwesomeIcon)
Vue.component('multiselect', Multiselect)
Vue.component('vueRecaptcha', VueRecaptcha)

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: 'G-7CJVDFDYMS' }
}, router)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
